var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticStyle:{"border":"1px solid rgba(0, 0, 0, 0.12)","width":"100%","height":"100%"},on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":_vm.mouseUp,"mouseleave":_vm.mouseUp,"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }